import rolesService from 'services/extroles.service';
import types from '../actionTypes';


export const createRole = (role) => (dispatch, getState) => {
    if (getState().rolesData.isCreating) {
        return;
    }

    dispatch({
        type: types.EXTROLES_CREATE_REQUEST,
    });

    return rolesService.createRole(role)
        .then(() => {
            dispatch({
                type: types.EXTROLES_CREATE_SUCCESS,
                payload: {role},
            });

            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.EXTROLES_CREATE_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const updateRole = (role) => (dispatch, getState) => {
    if (getState().rolesData.isUpdating) {
        return;
    }

    dispatch({
        type: types.EXTROLES_UPDATE_REQUEST,
    });

    return rolesService.updateRole(role)
        .then(() => {
            dispatch({
                type: types.EXTROLES_UPDATE_SUCCESS,
                payload: {role},
            });
            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.EXTROLES_UPDATE_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const activeRole = (roleId, active) => (dispatch, getState) => {
    if (getState().rolesData.isUpdating) {
        return;
    }

    dispatch({
        type: types.EXTROLES_ACTIVE_REQUEST,
    });

    return rolesService.activeRole(roleId, active)
        .then((role) => {
            dispatch({
                type: types.EXTROLES_ACTIVE_SUCCESS,
                payload: {role},
            });
            return role;
        })
        .catch((error) => {
            dispatch({
                type: types.EXTROLES_ACTIVE_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const fetchAllRoles = () => (dispatch, getState) => {
    if (getState().rolesData.isFetchingAllRolesList) {
        return Promise.reject();
    }

    dispatch({
        type: types.EXTROLES_FETCH_REQUEST,
    });

    return rolesService.getAllRoles()
        .then((roles) => {
            dispatch({
                type: types.EXTROLES_FETCH_SUCCESS,
                payload: { roles },
            });

            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.EXTROLES_FETCH_FAIL,
                payload: { error },
            });

            throw error;
        });
};

export const addUserToRole = (userId, roleId) => (dispatch, getState) => {
    if (getState().rolesData.isUpdating) {
        return;
    }

    dispatch({
        type: types.EXTROLES_ADD_ROLE_REQUEST,
    });

    return rolesService.addUserToRole(userId, roleId)
        .then(() => {
            dispatch({
                type: types.EXTROLES_ADD_ROLE_SUCCESS,
                payload: {},
            });
            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.EXTROLES_ADD_ROLE_FAIL,
                payload: {error},
            });

            throw error;
        });
};

export const removeUserToRole = (userId, roleId) => (dispatch, getState) => {
    if (getState().rolesData.isUpdating) {
        return;
    }

    dispatch({
        type: types.EXTROLES_REMOVE_ROLE_REQUEST,
    });

    return rolesService.removeUserToRole(userId, roleId)
        .then(() => {
            dispatch({
                type: types.EXTROLES_REMOVE_ROLE_SUCCESS,
                payload: {},
            });
            return true;
        })
        .catch((error) => {
            dispatch({
                type: types.EXTROLES_REMOVE_ROLE_FAIL,
                payload: {error},
            });

            throw error;
        });
};